import { useAuth } from "@clerk/react";
import { useEffect } from "react";

export default function SignOut() {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, [signOut]);

  return null;
}
